import type { AttributeOption, FiltersPayload } from '../types';

/**
 * Folds the Plan Metric attribute selection into the shared filter object.
 *
 * The metric sub-mode expresses its attribute picker as an inclusion on the
 * dimension's filter key rather than as a field of its own, so the request body
 * carries one merged `filters` value. Shared by the live grid query and the
 * report-export payload builder — a `current_view` export that dropped the
 * attribute would silently export a different dataset from the one on screen.
 */
export function mergeAttributeFilters(
    shared: FiltersPayload,
    dimKey: string | null,
    attributes: AttributeOption[],
): FiltersPayload {
    if (!dimKey || attributes.length === 0) return shared ?? {};
    const next: FiltersPayload = { ...(shared ?? {}) };
    const existing = next[dimKey] ?? { inclusion: [], exclusion: [] };
    next[dimKey] = {
        inclusion: [...existing.inclusion, ...attributes],
        exclusion: existing.exclusion,
    };
    return next;
}
